import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, SubscribableOrPromise, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Client } from 'src/app/clients-module/models/clientLocation';
import { ClientService } from 'src/app/clients-module/services/client.service';
import { AuthService } from 'src/app/services/auth.service';
import { ProcessorReportsService } from 'src/app/services/processor-reports.service';

@Component({
  selector: 'app-api-credentials-report-dialog',
  templateUrl: './api-credentials-report-dialog.component.html',
  styleUrls: ['./api-credentials-report-dialog.component.less']
})
export class ApiCredentialsReportDialogComponent implements OnInit, OnDestroy {
  processing : boolean;
  availableClients: Client[];
  clientSub$: Subscription;
  selectedClient: Client;
  loading: boolean = false;
  partyOn : Subject<any> = new Subject<any >();
  constructor(public modalRef: NgbModal, public procRpts : ProcessorReportsService, public auth: AuthService, public client: ClientService) { }
  ngOnDestroy(): void {
    this.modalRef.dismissAll();
    if(this.clientSub$) this.clientSub$.unsubscribe();
  }

  ngOnInit(): void {
    this.loading = true;
    this.clientSub$ = this.client.FetchLightClientList().pipe(tap(_ => 
        { this.availableClients = _; this.loading = false; })).subscribe();
  }

  cancel(): void {
    this.modalRef.dismissAll();
  }

  download(){
    console.log(this.selectedClient);
    var vals = {};
    vals['clientId'] = this.selectedClient.id;
    this.partyOn.next(vals);
  }

}
